import { render, staticRenderFns } from "./barcdeDisplayCertificate.vue?vue&type=template&id=61d434ce&scoped=true"
import script from "./barcdeDisplayCertificate.vue?vue&type=script&lang=js"
export * from "./barcdeDisplayCertificate.vue?vue&type=script&lang=js"
import style0 from "./barcdeDisplayCertificate.vue?vue&type=style&index=0&id=61d434ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d434ce",
  null
  
)

export default component.exports